<template>
  <ul v-if="assignments.length" class="assignments-list pr-2">
    <AssignmentsListItem
      v-for="assignment in assignments"
      :key="assignment.assignmentId"
      :item="assignment"
      :isPlayer="isPlayerAssignments"
      :status="status"
    />
  </ul>
  <span v-else class="secondary--text font-weight-bold">{{
    renderNoAssignmentsMessage
  }}</span>
</template>

<script>
import AssignmentsListItem from "./AssignmentsListItem";
import { mapActions, mapGetters } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { i18n } from "../../../plugins/i18n";

export default {
  name: "AssignmentsList",
  components: {
    AssignmentsListItem
  },
  props: ["status", "searchContextAssignments", "handleStatusChange"],
  data: () => ({}),
  computed: {
    ...mapGetters(ModuleTypes.STORAGE, [
      "activeOrganization",
      "isCreateAssignmentDialogOpened"
    ]),
    ...mapGetters(ModuleTypes.ASSIGNMENTS, [
      "assignments",
      "assignmentsListStatus"
    ]),
    isPlayerAssignments: function() {
      return !!this.$route.params?.playerId;
    },
    renderNoAssignmentsMessage() {
      if (
        this.searchContextAssignments?.isSearchContextAssignments &&
        !this.searchContextAssignments?.assignments?.length
      ) {
        return i18n.tc("common.no_results");
      } else if (!this.assignments?.length) {
        return i18n.tc("assignments.no_assignments");
      }
      return "";
    }
  },
  methods: {
    ...mapActions(ModuleTypes.ASSIGNMENTS, [
      "getAssignments",
      "getPlayerAssignments"
    ]),
    ...mapActions(ModuleTypes.STORAGE, ["setActiveOrganization"]),
    fetchAssignments() {
      this.getAssignments({
        organizationId:
          this.$route.params?.organizationId || this.$route.params?.orgId,
        status: this.status
      });
    },
    fetchPlayerAssignments() {
      this.getPlayerAssignments({
        organizationId: this.$route.params?.organizationId,
        playerId: this.$route.params?.playerId,
        status: this.status
      });
    },
    refreshList() {
      if (this.isPlayerAssignments) {
        this.fetchPlayerAssignments();
      } else {
        this.fetchAssignments();
      }
    }
  },
  mounted() {
    this.refreshList();
    this.setActiveOrganization({
      ...this.activeOrganization,
      id: this.$route.params?.organizationId || this.$route.params?.orgId
    });
  },
  watch: {
    status: function() {
      this.isPlayerAssignments
        ? this.fetchPlayerAssignments()
        : this.fetchAssignments();
    },
    isCreateAssignmentDialogOpened: function(value) {
      if (!value) {
        this.refreshList();
      }
    },

    assignmentsListStatus: function(newValue) {
      if (newValue) {
        this.handleStatusChange && this.handleStatusChange(newValue);
      }
    }
  }
};
</script>

<style scoped>
.assignments-list {
  width: 100%;
  position: absolute;
  top: 150px;
  left: 0;
  height: calc(100vh - var(--top-nav-desktop-height) - 180px);
  overflow-y: auto;
}

@media (max-width: 959px) {
  .assignments-list {
    height: calc(100vh - var(--top-nav-mobile-height) - 180px);
  }
}
</style>
